import setFindResultSet from '../setFindResultSet';
import setIsSearching from '../setIsSearching';
import updateFindResultTransactionId from '../updateFindResultTransactionId';
import addLocalCacheTransactionComplete from 'owa-recipient-common/lib/utils/addLocalCacheTransactionComplete';
import postProcessSuggestionsResult from './postProcessSuggestionsResult';
import { FindResultType } from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import PersonaType from 'owa-service/lib/contract/PersonaType';
import { action } from 'satcheljs/lib/legacy';

export default action('processCacheResult')(async function processCacheResult(
    recipientWell: FindControlViewState | RecipientWellWithFindControlViewState,
    cacheResults: PersonaType[],
    recipients: ReadWriteRecipientViewState[],
    resolveIfSingle: boolean
): Promise<void> {
    setIsSearching(recipientWell, false);
    setFindResultSet(recipientWell, cacheResults as FindRecipientPersonaType[]);
    updateFindResultTransactionId(recipientWell);
    addLocalCacheTransactionComplete(recipientWell);
    await postProcessSuggestionsResult(
        recipientWell,
        recipients,
        FindResultType.Cache,
        resolveIfSingle
    );
});
